var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { px2rem } from 'smartpi-core';
import styled from 'styled-components';
import { config } from '../../config';
var ToastBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n"], ["\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n"])));
var ToastBgBox = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  width: ", ";\n  height: 100vh;\n  background: transparent;\n"], ["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  width: ", ";\n  height: 100vh;\n  background: transparent;\n"])), px2rem(750));
var ToastBg = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  left: ", ";\n  top: 50%;\n  width: ", ";\n  min-height: ", ";\n  padding: ", ";\n  background: rgba(0, 0, 0, 0.65);\n  border-radius: ", ";\n  color: #fff;\n"], ["\n  position: relative;\n  left: ", ";\n  top: 50%;\n  width: ", ";\n  min-height: ", ";\n  padding: ", ";\n  background: rgba(0, 0, 0, 0.65);\n  border-radius: ", ";\n  color: #fff;\n"])), px2rem(230), px2rem(250), px2rem(110), px2rem(20), px2rem(20));
var ToastText = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: center;\n  min-height: ", ";\n  line-height: ", ";\n  font-size: ", ";\n"], ["\n  text-align: center;\n  min-height: ", ";\n  line-height: ", ";\n  font-size: ", ";\n"])), px2rem(40), px2rem(32), px2rem(24));
var ToastIcon = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0 auto ", ";\n  width: ", ";\n  height: ", ";\n  background: ", ";\n  background-size: 100%;\n"], ["\n  margin: 0 auto ", ";\n  width: ", ";\n  height: ", ";\n  background: ",
    ";\n  background-size: 100%;\n"])), px2rem(20), px2rem(60), px2rem(60), function (props) {
    switch (props.type) {
        case 'info':
            return "url(" + (config.CDN_DOMAIN + "/h5/toast/images/info.png") + ") no-repeat";
        case 'success':
            return "url(" + (config.CDN_DOMAIN + "/h5/toast/images/success.png") + ") no-repeat";
        case 'fail':
            return "url(" + (config.CDN_DOMAIN + "/h5/toast/images/fail.png") + ") no-repeat";
    }
});
var ToastComponent = /** @class */ (function (_super) {
    __extends(ToastComponent, _super);
    function ToastComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.transitionTime = 1000;
        _this.state = { notices: [] };
        _this.removeNotice = _this.removeNotice.bind(_this);
        return _this;
    }
    ToastComponent.prototype.getNoticeKey = function () {
        var notices = this.state.notices;
        return "notice-" + new Date().getTime() + "-" + notices.length;
    };
    ToastComponent.prototype.addNotice = function (notice) {
        var _this = this;
        var notices = this.state.notices;
        notice.key = this.getNoticeKey();
        // notices.push(notice);//展示所有的提示
        notices[0] = notice; // 仅展示最后一个提示
        this.setState({ notices: notices });
        if (notice.duration > 0) {
            setTimeout(function () {
                _this.removeNotice(notice.key);
            }, notice.duration * 1000);
        }
        return function () {
            _this.removeNotice(notice.key);
        };
    };
    ToastComponent.prototype.removeNotice = function (key) {
        var _this = this;
        var notices = this.state.notices;
        this.setState({
            notices: notices.filter(function (notice) {
                if (notice.key === key) {
                    if (notice.onClose)
                        setTimeout(notice.onClose, _this.transitionTime);
                    return false;
                }
                return true;
            }),
        });
    };
    ToastComponent.prototype.render = function () {
        var notices = this.state.notices;
        return (React.createElement(ToastBox, null, notices.map(function (notice) { return (React.createElement(ToastBgBox, { key: notice.key },
            React.createElement(ToastBg, null,
                React.createElement(ToastIcon, { type: notice.type }),
                React.createElement(ToastText, null, notice.content)))); })));
    };
    return ToastComponent;
}(Component));
export { ToastComponent };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=ToastComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/Toast/ToastComponent.js
// module id = 1084
// module chunks = 0